import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { closeForm } from "../feature/formSlice";
import { callAPI } from "../feature/APISlice";
import { showMessage } from "../feature/navbarSlice";

const BASE_URL = `${process.env.REACT_APP_PRODUCTION_API_URL}backend/api/admin/faqs`;

const getDefaultFormData = () => ({
  question: "",
  answer: "",
  orderNumber: "",
  is_active: false,
});

export default function FaqForm() {
  const dispatch = useDispatch();

  const { isOpen, editingId } = useSelector((s) => s.form);
  const { current, loading, error } = useSelector((s) => s.api);

  const [formData, setFormData] = useState(getDefaultFormData());

  
  useEffect(() => {
    if (editingId) {
      dispatch(callAPI({ method: "get", url: `${BASE_URL}/${editingId}` }));
    }
  }, [editingId, dispatch]);

  
  useEffect(() => {
    if (current && editingId) {
      setFormData({
        question: current.question ?? "",
        answer: current.answer ?? "",
        orderNumber: current.orderNumber ?? "",
        is_active: current.is_active ?? false,
      });
    }

    if (!editingId) setFormData(getDefaultFormData());
  }, [current, editingId]);

  
  const handleChange = (name, value) =>
    setFormData((p) => ({ ...p, [name]: value }));

  const handleClose = () => {
    dispatch(closeForm());
    setFormData(getDefaultFormData());
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const method = editingId ? "patch" : "post";
      const url = editingId ? `${BASE_URL}/${editingId}` : BASE_URL;

      await dispatch(callAPI({ method, url, data: formData })).unwrap();

      dispatch(
        showMessage({
          type: "success",
          text: `FAQ ${editingId ? "updated" : "created"} successfully`,
        })
      );

      handleClose();
    } catch (err) {
      dispatch(
        showMessage({
          type: "error",
          text: err || "Something went wrong",
        })
      );
    }
  };

  if (!isOpen) return null;

  
  return (
    <div className="admin-form-overlay">
      <div
        className="admin-form-wrapper"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="admin-form-close" onClick={handleClose}>
          ✕
        </button>

        <h2>{editingId ? "Edit FAQ" : "Add FAQ"}</h2>

        <form className="admin-contact-form" onSubmit={handleSubmit}>
          
          <div className="admin-form-group">
            <label>Question</label>
            <input
              value={formData.question}
              onChange={(e) =>
                handleChange("question", e.target.value)
              }
              required
            />
          </div>

          
          <div className="admin-form-group">
            <label>Answer</label>
            <textarea
              rows={4}
              value={formData.answer}
              onChange={(e) =>
                handleChange("answer", e.target.value)
              }
              required
            />
          </div>

          
          <div className="admin-form-group">
            <label>Order Number</label>
            <input
              type="number"
              value={formData.orderNumber}
              onChange={(e) =>
                handleChange("orderNumber", e.target.value)
              }
            />
          </div>

          
          <label>
            <input
              type="checkbox"
              checked={formData.is_active}
              onChange={(e) =>
                handleChange("is_active", e.target.checked)
              }
            />{" "}
            Active
          </label>

          <div className="admin-button-row">
            <button
              type="button"
              className="admin-btn outline"
              onClick={handleClose}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="admin-btn filled"
              disabled={loading}
            >
              {loading
                ? "Saving..."
                : editingId
                ? "Update"
                : "Save"}
            </button>
          </div>

          {error && <p className="error-text">{error}</p>}
        </form>
      </div>
    </div>
  );
}
